import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Spin, Select, DatePicker, InputNumber } from 'antd';
import ViewList from '@material-ui/icons/ViewList';
// import { green } from '@material-ui/core/colors';
import Highlighter from 'react-highlight-words';
import * as SignalR from '@aspnet/signalr';
import moment from 'moment';
import 'antd/dist/antd.css';

const { Title } = Typography;
const { Option } = Select;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'AuditLogStore'
)
@observer
class AuditLogListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
            fromDate: undefined,
            toDate: undefined,
            area: 'Task',
            areaId: null,
            action: 'UPDATE',
            username: '',
            pagination: {
                current: 1,
                pageSize: 10,
            }
        }
    }

    componentDidMount() {
        let fromDateTime = moment();
        fromDateTime.hour(0);
        fromDateTime.minute(0);
        fromDateTime.second(0);

        let toDateTime = moment();
        toDateTime.hour(23);
        toDateTime.minute(59);
        toDateTime.second(0);

        this.setState({
            fromDate: fromDateTime,
            toDate: toDateTime,
            area: 'Task',
            areaId: null,
            action: 'UPDATE',
            username: '',
        }, () => {
            const { pagination } = this.state;
            this.getFilterData({ pagination });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    // Server Table Pagination

    getFilterData = (params = {}) => {
        const fromDate = moment(this.state.fromDate).format('YYYY-MM-DDTHH:mm:ss')
        const endDate = moment(this.state.toDate).format('YYYY-MM-DDTHH:mm:ss')

        this.props.AuditLogStore.initAuditLog(
            fromDate,
            endDate,
            params.pagination.current,
            params.pagination.pageSize,
            this.state.area,
            this.state.areaId,
            this.state.action,
            this.state.username
        ).then(() => {
            const { totalData } = this.props.AuditLogStore;

            this.setState({
                pagination: {
                    ...params.pagination,
                    total: totalData
                }
            })
        });
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.getFilterData({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
        });
    }

    // ON CLICK

    updateAuditLogOnClick = (id) => {
        this.props.AuditLogStore.initUpdateAuditLog(id);
    }

    // TABLE SETTING

    getColumns = () => {
        return [
            {
                title: 'Created Date',
                dataIndex: 'createdDateString',
                key: 'createdDateString',
            },
            {
                title: 'Area',
                dataIndex: 'area',
                key: 'area',
            },
            {
                title: '#ID',
                dataIndex: 'areaId',
                key: 'areaId',
            },
            {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
            },
            {
                title: 'Username',
                dataIndex: 'username',
                key: 'username',
            },
            {
                title: 'Action',
                dataIndex: 'id',
                key: 'id',
                render: id => (
                    <span>
                        <Button onClick={() => this.updateAuditLogOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <ViewList style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    fromDateChange = (e) => {
        this.setState({
            fromDate: e
        })
    }

    toDateChange = (e) => {
        this.setState({
            toDate: e
        })
    }

    areaChange = (value) => {
        this.setState({
            area: value
        })
    }

    areaIdChange = (value) => {
        this.setState({
            areaId: value
        })
    }

    actionChange = (value) => {
        this.setState({
            action: value
        })
    }

    usernameChange = (e) => {
        this.setState({
            username: e.target.value
        })
    }

    searchData = () => {
        const { pagination } = this.state;
        this.getFilterData({ pagination });
    }

    render() {
        const {
            auditLogs,
            auditLogListLoading,
            areas,
            actions
        } = this.props.AuditLogStore;

        const { pagination } = this.state;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3}>List</Title>
                        <div style={{ display: 'flex', alignItems: 'center', height: 48 }}>
                            <div style={{ paddingRight: 8 }}>From Date</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.fromDate}
                                    onChange={(e) => this.fromDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8 }}>To Date</div>
                            <div style={{ paddingRight: 16 }}>
                                <DatePicker
                                    format='YYYY/MM/DD'
                                    value={this.state.toDate}
                                    onChange={(e) => this.toDateChange(e)}
                                />
                            </div>
                            <div style={{ paddingRight: 8 }}>Area</div>
                            <div style={{ paddingRight: 16 }}>
                                <Select
                                    value={this.state.area}
                                    onChange={(value) => this.areaChange(value)}
                                    className='stm-width-150'>
                                    {
                                        areas.map(area => {
                                            return (<Option key={area.value} value={area.value}>{area.label}</Option>)
                                        })
                                    }
                                </Select>
                            </div>
                            <div style={{ paddingRight: 8 }}>#ID</div>
                            <div style={{ paddingRight: 16 }}>
                                <InputNumber
                                    className='stm-width-100'
                                    value={this.state.areaId}
                                    onChange={this.areaIdChange}
                                />
                            </div>
                            <div style={{ paddingRight: 8 }}>Action</div>
                            <div style={{ paddingRight: 16 }}>
                                <Select
                                    value={this.state.action}
                                    onChange={(value) => this.actionChange(value)}
                                    className='stm-width-120'>
                                    {
                                        actions.map(action => {
                                            return (<Option key={action.value} value={action.value}>{action.label}</Option>)
                                        })
                                    }
                                </Select>
                            </div>
                            <div style={{ paddingRight: 8 }}>Username</div>
                            <div style={{ paddingRight: 16 }}>
                                <Input value={this.state.username} placeholder='Username' onChange={this.usernameChange} />
                            </div>
                            <div>
                                <Button onClick={this.searchData}>Search</Button>
                            </div>
                        </div>
                    </div>
                    <Spin spinning={auditLogListLoading}>
                        <Table
                            columns={this.getColumns()}
                            rowKey={record => record.id}
                            dataSource={auditLogs}
                            pagination={pagination}
                            onChange={this.handleTableChange} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default AuditLogListPage;
